export default __webpack_public_path__ + "static/UNAC1-b3179f1cef2f29694c579f2b44635910.png";